import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

const useStyles = createUseStyles(theme => ({
  '@global': {
    '@font-face': [
      {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 300,
        // src: `
        //   local('Lato Light'),
        //   url('./static/fonts/Lato-Light.ttf') format('trueType')
        // `,
      },
      {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        // src: `
        //   local('Lato Regular'),
        //   url('./static/fonts/Lato-Regular.ttf') format('trueType')
        // `,
      },
      {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        // src: `
        //   local('Lato Bold'),
        //   url('./static/fonts/Lato-Bold.ttf') format('trueType')
        // `,
      },
      {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 300,
        // src: `
        //   local('Roboto Light'),
        //   url('./static/fonts/Roboto-Light.ttf') format('trueType')
        // `,
      },
      {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        // src: `
        //   local('Roboto Regular'),
        //   url('./static/fonts/Roboto-Regular.ttf') format('trueType')
        // `,
      },
      {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 700,
        // src: `
        //   local('Roboto Bold'),
        //   url('./static/fonts/Roboto-Bold.ttf') format('trueType')
        // `,
      }
    ],
    'html, body': {
      // position: 'fixed',
      // top: 0,
      // right: 0,
      // bottom: 0,
      // left: 0,
      // overflow: 'hidden',
      fontFamily: theme.fontFamily.primary,
    },
    html: {
      'line-height': 1.125,
      '-webkit-text-size-adjust': '100%',
    },
    body: {
      color: theme.fontColor.secondary,
      fontSize: theme.fontSize.sm,
      '-webkit-font-smoothing': 'antialiased',
      margin: 0,
      '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)',
    },
    svg: {
      fill: 'currentColor',
    },
  }
}), {
  name: 'CssBaseline'
});

const CssBaseLine = () => {
  const theme = useTheme();
  useStyles(theme);
  return <></>;
}

export default CssBaseLine;
